import { MemoizedSelector, createSelector } from '@ngrx/store';
import { Order } from '../../../../../core/model';
import { CheckoutState, StateWithCheckout } from '../checkout-state';
import { getCheckoutState } from './feature.selector';

export const getActiveOrderProcess: MemoizedSelector<StateWithCheckout, Order | undefined> = createSelector(
  getCheckoutState,
  (state: CheckoutState) => state?.activeOrderProcess || undefined
);
